import Vue from 'vue';
import Vuex from 'vuex';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import defaultStore from '../default';
import deepmerge from 'deepmerge';

Vue.use(Vuex);

export function createStore() {
  const clientStore = {
    state: {
      error: null,
    },
    actions,
    mutations,
    getters,
    modules: {},
  };
  const store = deepmerge(defaultStore, clientStore);
  return new Vuex.Store(store);
}

export default createStore;
